import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', () => {
  const isAdmin = ref(false)
  const isLoading = ref(false)
  const { data } = useAuth()

  // Check user role
  const checkUserRole = async (userId?: number | string) => {
    if (!userId) {
      isAdmin.value = false
      return
    }

    isLoading.value = true
    try {
      const response = (await $fetch(`/api/admin/users/${userId}`)) as {
        data: { role: string }
      }
      isAdmin.value = response.data?.role === 'ADMIN'
    } catch (error) {
      // If we can't fetch the user or get a permission error, they're not admin
      console.log('User role check failed, assuming non-admin:', error)
      isAdmin.value = false
    } finally {
      isLoading.value = false
    }
  }

  // Initialize user role checking with watcher
  const initUserRoleWatcher = () => {
    watch(
      () => data.value?.user?.id,
      async userId => {
        if (userId) {
          await checkUserRole(userId)
        }
      },
      { immediate: true }
    )
  }

  // Manual refresh of user role (useful after role changes)
  const refreshUserRole = async () => {
    const userId = data.value?.user?.id
    if (userId) {
      await checkUserRole(userId)
    }
  }

  return {
    isAdmin: readonly(isAdmin),
    isLoading: readonly(isLoading),
    initUserRoleWatcher,
    refreshUserRole,
  }
})
